import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';

/**
 * AssignmentTypeBadge Component
 * Displays a badge indicating whether a ticket is EC or MPLID.
 * Tickets without assignmentType (historical) default to MPLID.
 */
const AssignmentTypeBadge = ({ assignmentType }) => {
  if (assignmentType === 'ec') {
    return <Badge bg="info">EC</Badge>;
  }
  return <Badge bg="secondary">MPLID</Badge>;
};

AssignmentTypeBadge.propTypes = {
  assignmentType: PropTypes.string,
};

export default AssignmentTypeBadge;
